import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyComponent = lazyForPaint(
	() => import(/* webpackChunkName: "async-plans-item-visibility-permission" */ './index.tsx'),
);

type Props = {
	children: React.ReactNode;
};

export const AsyncPlanPermissions = (props: Props): React.JSX.Element => (
	<Placeholder name="jira-plans-item-visibility-permission" fallback={null}>
		<LazyComponent {...props} />
	</Placeholder>
);

export default AsyncPlanPermissions;
